<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-card-title>{{role && role.id ? 'Update' :'Add'}} Role</v-card-title>
      <v-divider/>
      <v-card-text class="pb-0 pt-4">
        <v-form ref="form">
          <v-text-field outlined dense counter="50" :rules="[fieldRules.required]" v-model="roleName" label="Name"/>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="crupdate()" :loading="busy">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'PlanningSchedulingRolesCrupdate',
	props: {
    value: {type:Boolean,required:true},
    role: {type:Object, required:false}
  },
  data() {
    return {
      show: false,
      busy: false,
      roleName: ''
    }
  },
  watch: {
    value() {
      this.roleName = this.role?.name ?? '';
      this.show = this.value;
    },
    role() {
      this.roleName = this.role?.name ?? '';
    }
  },
  methods: {
    async crupdate() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.busy = true;
      const results = await this.$apiCall(`mutation PlanningSchedulingRolesCrupdate($input:RoleInput!) {
                                              roleCrupdate(input:$input) {
                                                id,name,users
                                              }
                                            }`,
                                           {input:{name:this.roleName,id:this.role?.id}});
      this.busy = false;
      if (!results.error) {
        this.show = false;
        this.$emit('input', false);
        this.$emit(this.role ? 'update' : 'create', results.data.roleCrupdate);
      }
    },
  }
}
</script>
